import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../../components/grid/headerTemplate/headerTemplate.vue";

export default {
	extends: gridClientBase,
	components: {},

	data: function() {
		return {
			loading: false,
			savePendingRequest: null

			// items: []
		};
	},

	created() {
		this.getData();
		var newItem = {
			id: 0,
			name: "",
			code: "",
			description: ""
		};
		this.defaultAddRow = newItem;
		this.sort = [{ field: "name", dir: "asc" }];
	},

	/* metodi */
	methods: {
		saveData: function() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = api
					.postDivisionsData(this.createdItems, this.updatedItems, this.deletedItems)
					.then(res => {
						self.createdItems = [];
						self.updatedItems = [];
						self.deletedItems = [];

						self.isInEditMode = false;
						self.getData();
					})
					.catch(err => {
						console.log("KO" + err);
					})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},

		getData: function() {
			var self = this;
			this.loading = true;

			this.getDivisions(self);
		},

		getDivisions: function(self) {
			api.getDivisionsData().then(res => {
				self.loading = false;
				self.items = res.map(function(item) {
					return {
						id: item.id,
						code: item.code,
						name: item.name,
						description: item.description
					};
				});
			});
		},

		switchEditMode: function() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},

	/* visualizzazione risultati */
	computed: {
		columns: function() {
			return [
				{
					field: "code",
					title: "Codice",
					width: "150",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: false
				},
				{
					field: "name",
					title: "nome",
					width: "200",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "description",
					title: "descrizione",
					width: "429",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "",
					title: "",
					width: "",
					cell: "",
					headerCell: "",
					filterable: false,
					sortable: false
				}
				/*
				{
					cell: cellDeleteCommand,
					width: "45",
					minResizableWidth: "45",
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
				*/
			];
		}
	}
};
